import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { setCurrentVideoPosition } from 'app/actions/videoPlayer';

const UPDATE_INTERVAL = 3;

const CurrentPosition = (props) => {
    const { videoId, position } = props;
    const [lastUpdated, setLastUpdated] = useState(0);
    const dispatch = useDispatch();

    useEffect(() => {
        const roundedPosition = Math.round(position);
        const shouldUpdate = Math.abs(roundedPosition - lastUpdated) >= UPDATE_INTERVAL;

        if (!shouldUpdate) {
            return;
        }

        setLastUpdated(roundedPosition);
        dispatch(setCurrentVideoPosition(videoId, roundedPosition));
    }, [lastUpdated, position, videoId, dispatch]);

    return null;
};

CurrentPosition.propTypes = {
    videoId: PropTypes.string.isRequired,
    position: PropTypes.number.isRequired,
};

export default CurrentPosition;
